// Paths
export const CONFIRM_PHONE_PATH = '/confirmacao-telefone'
export const CONFIRM_EMAIL_PATH = '/confirmacao-email-enviado'

// URLs
export const WALLET_URL = 'https://wallet.olx.com.br'
export const PROFILE_URL = 'https://www.olx.com.br/perfil'
